import { createAction } from 'redux-actions'
import querystring from 'querystring'
import { identity } from 'lodash'
// import log from 'blazar-sentry'

import { actionCreators as api } from 'reduxBits/api'

const prefix = 'ReplyTime:'
export const FETCH_REPLY_TIME = `${prefix} Fetch reply time for ad.`
export const REQUEST_REPLY_TIME = `${prefix} Request reply time for ad.`
export const RECEIVE_REPLY_TIME = `${prefix} Receive reply time for ad.`

const requestReplyTime = createAction(REQUEST_REPLY_TIME)
const receiveReplyTime = createAction(RECEIVE_REPLY_TIME, identity, (payload, adId) => adId)

const fetchReplyTime = (adId) => async (dispatch) => {
  const qs = querystring.stringify({ ad_id: adId })
  dispatch(requestReplyTime(adId))

  try {
    const response = await dispatch(api.fetch(`trust-be/v1/reply_time?${qs}`))

    dispatch(receiveReplyTime(response, adId))
  } catch (error) {
    dispatch(receiveReplyTime(error, adId))

    // if (error.status && error.status < 500) {
    //   return
    // }
    //
    // Temporarily disable logging until api errors are fixed.
    // log.error(error, {
    //   fingerprint: ['api', 'trust-be/v1/reply_time?ad_id=:adId'],
    // })
  }
}

export const actionCreators = {
  fetchReplyTime,
}
